export const TYPOGRAPHY_TEXT = `Don't have your playground access details yet?`;
export const LINK_TEXT = 'Contact us';
